import { Menu } from "antd";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const AddsNav = () => {
  const [activeLink, setActiveLink] = useState("ads");
  const location = useLocation();
  const currentLocation = location.pathname.split("/");
  const handleLinkClick = (key) => {
    setActiveLink(key);
  };
  useEffect(() => {
    setActiveLink(currentLocation[currentLocation.length - 1]);
  }, [currentLocation]);

  return (
    <div className="pt-2 px-2">
      <Menu
        mode="horizontal"
        className="bg-boxGrey  h-5.4 w-44 border-2 rounded"
      >
        <div className="flex items-center space-x-2 mr-1 ml-2">
          <Menu.Item
            key="ads"
            className={`${
              activeLink === "ads"
                ? "!bg-white !text-black"
                : "!text-grey !bg-boxGrey"
            } `}
            onClick={() => handleLinkClick("ads")}
          >
            <Link to="/main/ads">New Ads</Link>
          </Menu.Item>
          <Menu.Item
            key="pending"
            className={`${
              activeLink === "pending-ads"
                ? "!bg-white !text-black"
                : "!text-grey !bg-boxGrey"
            } `}
            onClick={() => handleLinkClick("pending")}
          >
            <Link to="/main/ads/pending-ads">Pending Ads</Link>
          </Menu.Item>
          <Menu.Item
            key="current-ads"
            className={`${
              activeLink === "current-ads"
                ? "!bg-white !text-black"
                : "!text-grey !bg-boxGrey"
            }`}
            onClick={() => handleLinkClick("current-ads")}
          >
            <Link to="/main/ads/current-ads">Current Ads Running</Link>
          </Menu.Item>
        </div>
      </Menu>
    </div>
  );
};

export default AddsNav;
